webpackJsonp([35783957827783],{

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CarouselCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateManager = __webpack_require__(62);
	
	var _link = __webpack_require__(9);
	
	var _styles = __webpack_require__(950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarouselCard = exports.CarouselCard = function (_React$PureComponent) {
		_inherits(CarouselCard, _React$PureComponent);
	
		function CarouselCard() {
			_classCallCheck(this, CarouselCard);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		CarouselCard.prototype.render = function render() {
			var _props = this.props,
			    background = _props.background,
			    body = _props.body,
			    date = _props.date,
			    endDate = _props.endDate,
			    location = _props.location,
			    title = _props.title,
			    to = _props.to;
	
	
			var formattedDate = (0, _dateManager.format)(date, endDate);
	
			return _react2.default.createElement(
				_link.Link,
				{ className: _styles.wrapperLinkStyle, to: to, 'data-component': 'Card' },
				_react2.default.createElement(
					'article',
					{ className: (0, _styles.wrapperStyle)(background) },
					_react2.default.createElement(
						'h1',
						{ className: _styles.titleStyle },
						title
					),
					_react2.default.createElement(
						'p',
						{ className: _styles.bodyStyle },
						body
					),
					location && _react2.default.createElement(
						'p',
						{ className: _styles.metaLocationStyle },
						location
					),
					formattedDate && _react2.default.createElement(
						'p',
						{ className: _styles.metaDateStyle },
						formattedDate
					)
				)
			);
		};
	
		return CarouselCard;
	}(_react2.default.PureComponent);
	
	CarouselCard.propTypes = {
		background: _propTypes2.default.string,
		body: _propTypes2.default.string,
		date: _propTypes2.default.string,
		endDate: _propTypes2.default.string,
		location: _propTypes2.default.string,
		title: _propTypes2.default.string,
		to: _propTypes2.default.string
	};

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(948);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.metaLocationStyle = exports.metaDateStyle = exports.bodyStyle = exports.titleStyle = exports.wrapperStyle = exports.wrapperLinkStyle = undefined;
	
	var _css;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _locationIcon = __webpack_require__(869);
	
	var _locationIcon2 = _interopRequireDefault(_locationIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapperLinkStyle = /*#__PURE__*/exports.wrapperLinkStyle = (0, _emotion.css)({
		textDecoration: 'none',
		display: 'block'
	});
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(background) {
		var _hover;
	
		return (/*#__PURE__*/(0, _emotion.css)(_extends({
				padding: background ? '190px 0 0' : '0',
				position: 'relative',
				zIndex: '1'
			}, background ? {
				'&:after': {
					borderRadius: '6px',
					content: "' '",
					display: 'block',
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '190px',
					background: 'url(' + background + ') no-repeat top center',
					backgroundSize: 'cover'
				}
			} : null, {
				'&:hover': (_hover = {}, _hover['& .' + titleStyle] = {
					textDecoration: 'underline'
				}, _hover)
			}))
		);
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)({
		margin: '12px 0'
	}));
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css = {
		marginTop: 0,
		marginBottom: '10px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css)));
	
	var metaStyle = {
		fontSize: '12px',
		lineHeight: '18px',
		margin: '10px 0 0',
		textAlign: 'left'
	};
	
	var metaDateStyle = /*#__PURE__*/exports.metaDateStyle = (0, _emotion.css)(_extends({}, metaStyle, {
		color: '#8A8B8C'
	}));
	
	var metaLocationStyle = /*#__PURE__*/exports.metaLocationStyle = (0, _emotion.css)(_extends({}, metaStyle, {
		color: _globalStyles.darkGrey,
		fontWeight: 500,
		paddingLeft: '28px',
		background: 'transparent url(' + _locationIcon2.default + ') no-repeat left center'
	}));

/***/ }),

/***/ 3674:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIHN0cm9rZT0iI0VCRUJFQyIgZmlsbD0iI0ZGRiIgY3g9IjI1IiBjeT0iMjUiIHI9IjI1Ii8+PHBhdGggZD0iTTM0LjAzNSAyNC4yNTNsLTYuNzQxLTYuOTQ2YTEgMSAwIDAgMC0xLjQ0NSAwbC0uNjEyLjYzYTEuMDYxIDEuMDYxIDAgMCAwLS4yOTguNzQ1YzAgLjI4Mi4xMDYuNTU1LjI5OC43NTNsMy45MzMgNC4wNjFIMTYuNjc1Yy0uNTYzIDAtMS4wMDguNDU0LTEuMDA4IDEuMDM1di44OTJjMCAuNTguNDQ1IDEuMDggMS4wMDggMS4wOGgxMi41NGwtMy45NzggNC4wODRhMS4wNDUgMS4wNDUgMCAwIDAtLjI5OC43MzdjMCAuMjgyLjEwNi41NDMuMjk4Ljc0MWwuNjEyLjYyOWExIDEgMCAwIDAgMS40NDUtLjAwMWw2Ljc0MS02Ljk0NmMuMTkzLS4yLjMtLjQ2NS4yOTgtLjc0NyAwLS4yODMtLjEwNS0uNTQ5LS4yOTgtLjc0N3oiIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iI0YwNUI1RSIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Carousel = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(977);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Carousel = exports.Carousel = function (_React$Component) {
		_inherits(Carousel, _React$Component);
	
		function Carousel(props) {
			_classCallCheck(this, Carousel);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				page: 0,
				leftEnabled: false,
				rightEnabled: false
			};
	
			_this.scrollLeft = function () {
				var outer = _this.outerRef.current;
				var inner = _this.innerRef.current;
				if (outer == null || inner == null) return;
	
				var outerWidth = outer.clientWidth;
				var innerWidth = inner.scrollWidth;
				var innerLeft = inner.offsetLeft;
				var page = innerLeft < 0 ? Math.round(innerLeft / outerWidth) + 1 : -Math.floor(innerWidth / outerWidth);
				inner.style.left = 'calc(' + page * 100 + '% - ' + -page * 24 + 'px)';
			};
	
			_this.scrollRight = function () {
				var outer = _this.outerRef.current;
				var inner = _this.innerRef.current;
				if (outer == null || inner == null) return;
	
				var outerWidth = outer.clientWidth;
				var innerWidth = inner.scrollWidth;
				var innerLeft = inner.offsetLeft;
				var upperLim = Math.floor(innerWidth / outerWidth) * outerWidth;
				if (-innerLeft < upperLim) {
					var page = Math.round(innerLeft / outerWidth) - 1;
					inner.style.left = 'calc(' + page * 100 + '% - ' + -page * 24 + 'px)';
				} else {
					inner.style.left = '0';
				}
			};
	
			_this.innerRef = _react2.default.createRef();
			_this.outerRef = _react2.default.createRef();
			return _this;
		}
	
		Carousel.prototype.componentDidMount = function componentDidMount() {
			if (_react2.default.Children.count(this.props.children) > 3) {
				this.setState({
					rightEnabled: true,
					leftEnabled: true
				});
			}
		};
	
		Carousel.prototype.render = function render() {
			var _state = this.state,
			    leftEnabled = _state.leftEnabled,
			    rightEnabled = _state.rightEnabled;
	
			return _react2.default.createElement(
				'div',
				{ className: _styles.wrapperStyle },
				_react2.default.createElement(
					'div',
					{ className: _styles.maskStyle, ref: this.outerRef },
					_react2.default.createElement(
						'div',
						{ className: _styles.innerStyle, ref: this.innerRef },
						this.props.children
					)
				),
				leftEnabled && _react2.default.createElement('button', { className: (0, _styles.arrowStyle)('left'), onClick: this.scrollLeft }),
				rightEnabled && _react2.default.createElement('button', { className: (0, _styles.arrowStyle)('right'), onClick: this.scrollRight })
			);
		};
	
		return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = {
		children: _propTypes2.default.array
	};

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(975);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.innerStyle = exports.maskStyle = exports.wrapperStyle = exports.arrowStyle = undefined;
	
	var _dataComponent;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _arrow = __webpack_require__(3674);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowStyle = exports.arrowStyle = function arrowStyle(side) {
		return (/*#__PURE__*/(0, _emotion.css)({
				width: '51px',
				height: '51px',
				display: 'block',
				position: 'absolute',
				top: '70px',
				left: side === 'left' ? '-26px' : 'auto',
				right: side === 'left' ? 'auto' : '-26px',
				padding: '0',
				border: 'none',
				outline: 'none',
				zIndex: '1',
				filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.18))',
				cursor: 'pointer',
	
				'&:after': {
					content: '" "',
					display: 'block',
					width: '100%',
					height: '100%',
					background: 'transparent url(' + _arrow2.default + ') no-repeat',
					transform: side === 'left' ? 'scaleX(-1)' : 'none'
				}
			})
		);
	};
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)({
		position: 'relative',
		width: '100%'
	});
	
	var maskStyle = /*#__PURE__*/exports.maskStyle = (0, _emotion.css)({
		overflow: 'hidden',
		width: '100%'
	});
	
	var innerStyle = /*#__PURE__*/exports.innerStyle = (0, _emotion.css)({
		display: 'flex',
		alignItems: 'stretch',
		position: 'relative',
		left: '0',
		transition: 'all 300ms',
	
		'& > [data-component=Card]': (_dataComponent = {
			width: 'calc((100% - 48px) / 3)',
			flexShrink: '0',
			margin: '0 12px'
	
		}, _dataComponent['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
			width: 'calc((100% - 24px) / 2)'
		}, _dataComponent['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
			width: '100%'
		}, _dataComponent['&:first-of-type'] = {
			marginLeft: '0'
		}, _dataComponent['&:last-of-type'] = {
			marginRight: '0'
		}, _dataComponent)
	});

/***/ }),

/***/ 3709:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTI5cHgiIGhlaWdodD0iMTM2MHB4IiB2aWV3Qm94PSIwIDAgNTI5IDEzNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IjEtaG9tZXBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLWhvbWVwYWdlLS0tZmluYWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MTEuMDAwMDAwLCAtMjk5LjAwMDAwMCkiIGZpbGw9IiNGNkY2RjYiPgogICAgICAgICAgICA8ZyBpZD0iby1lbGVtZW50IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MTEuMDAwMDAwLCAyNzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTA2NC41NzQyLDcwMC4zMjUzMzggQzEwNjQuMzU1ODEsNTM0LjkzNTU0OCA5NjQuMjc4MTA3LDQwNi43MzYxNjcgODE3LjA4MjUzNiwzODMuMjg4ODk4IEM1NzEuODI5MzgyLDM0NC4yMzYzNDYgMzkwLjE4MjYyMiw1NDEuNDkyMzkgNDQ3Ljk3NDM1NSw3ODMuOTkwNjQ2IEM0ODMuMjcxODA5LDkzMi4wOTY2IDU4NS40MjQyMjUsMTAyOC44NzU1OSA3MTQuNDkzMzM4LDEwMzYuNDgxNTMgQzkyNi4wMDUwNzUsMTA0OC45NjU3NiAxMDY0Ljg3NDQ5LDkxNS42MjU4MTMgMTA2NC41NzQyLDcwMC4zMjUzMzggTTE1MDQuNjA0ODgsNzAwLjQ1NjQ3NSBDMTUwNC40NDEwOCwxMTExLjg1ODk5IDExODAuMjY2ODYsMTQxOS44NDY5OSA3NDkuOTI3Mjg3LDE0MTcuNDg2NTIgQzMxOS4yMDU1MjksMTQxNS4wOTk4MyAwLjUxODM4MjgwMiwxMTExLjI4MTk5IDAuMTM2MTk4NDU2LDcwMi42ODU4MDEgQy0wLjI3MzI4NDc3MSwyOTcuNjMwMzEgMzE2LjkzOTcyMiwwLjkyMDA4MTg0MSA3NTAuOTEwMDQ3LDAuNTAwNDQzOTMzIEMxMTg0Ljc5ODQ3LDAuMDgwODA2MDI0NCAxNTA0Ljc2ODY3LDI5Ny4yMTA2NzMgMTUwNC42MDQ4OCw3MDAuNDU2NDc1IiBpZD0iYmciPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 3710:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-h264.140242c3.mp4";

/***/ }),

/***/ 3711:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 3712:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-vp8.fef30f36.webm";

/***/ }),

/***/ 3713:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/who-we-are.7831023f.svg";

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whoAreWeInnerStyle = exports.whoAreWeSectionStyle = exports.ourPartnersLogosWrapperStyle = exports.ourPartnersSectionStyle = exports.updatesSectionInnerStyle = exports.updatesInnerWrapperStyle = exports.updatesSectionStyle = exports.resourceSectionInnerStyle = exports.resourceSectionStyle = exports.atRiskRightStyle = exports.atRiskLeftStyle = exports.areYouAtRiskSectionStyle = exports.disordersMobileStyle = exports.disordersRightStyle = exports.disordersLeftStyle = exports.whatAreEatingDisordersStyle = exports.bodyTextStyle = exports.titleStyle = exports.cardsStyle = exports.heroBodyCTAStyle = exports.heroBodyStyle = exports.heroTitleStyle = exports.heroBackgroundStyle = exports.heroStyle = exports.innerWrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _extends2, _css3, _extends3, _css4, _css5, _css6, _extends4, _div, _css7, _css8, _css9, _css10, _css11, _css12, _a, _css13, _css14, _css15, _css16;
	
	var _emotion = __webpack_require__(6);
	
	var _circleBg = __webpack_require__(3709);
	
	var _circleBg2 = _interopRequireDefault(_circleBg);
	
	var _whoWeAre = __webpack_require__(3713);
	
	var _whoWeAre2 = _interopRequireDefault(_whoWeAre);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		overflowX: 'hidden'
	});
	
	var heroStyle = /*#__PURE__*/exports.heroStyle = (0, _emotion.css)((_css = {
		boxSizing: 'border-box',
		position: 'relative'
	
	}, _css['@media (min-width: ' + _globalStyles.mobileMinWidthBreakpoint + 'px)'] = {
		paddingTop: '22px',
		height: '396px'
	}, _css['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		paddingTop: '62px',
		height: '444px'
	}, _css));
	
	var heroBackgroundStyle = exports.heroBackgroundStyle = function heroBackgroundStyle(bgImage) {
		var _video, _css2;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css2 = {
				position: 'absolute',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				overflow: 'hidden',
	
				'& > video': (_video = {
					minWidth: '100%',
					minHeight: '100%',
					width: 'auto',
					height: 'auto',
					position: 'absolute',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)'
	
				}, _video['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
					display: 'none'
				}, _video)
	
			}, _css2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
				background: 'url(' + bgImage + ') no-repeat center',
				backgroundSize: 'cover'
			}, _css2))
		);
	};
	
	var heroTitleStyle = /*#__PURE__*/exports.heroTitleStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, (_extends2 = {
		fontWeight: 'normal',
		margin: 0,
		color: '#fff',
		position: 'relative',
		zIndex: '1'
	
	}, _extends2['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		width: '620px'
	}, _extends2)));
	
	var heroBodyStyle = /*#__PURE__*/exports.heroBodyStyle = (0, _emotion.css)((_css3 = {
		color: '#fff',
		position: 'relative',
		zIndex: '1'
	
	}, _css3['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		width: '620px'
	}, _css3));
	
	var heroBodyCTAStyle = /*#__PURE__*/exports.heroBodyCTAStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, (_extends3 = {
	
		color: '#fff',
		margin: '0 0 10px',
		position: 'relative',
		zIndex: '1'
	
	}, _extends3['@media (min-width: ' + _globalStyles.mobileMinWidthBreakpoint + 'px)'] = {
		fontSize: '16px',
		lineHeight: '19px'
	}, _extends3['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		fontSize: '18px',
		lineHeight: '22px'
	}, _extends3)));
	
	var cardsStyle = /*#__PURE__*/exports.cardsStyle = (0, _emotion.css)({
		position: 'relative',
		zIndex: '1',
		marginTop: '-146px'
	});
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)((_css4 = {
		marginBottom: '24px',
		width: '525px'
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		lineHeight: '47px'
	}, _css4['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '20px',
		lineHeight: '23px',
		width: '286px'
	}, _css4)));
	
	var bodyTextStyle = exports.bodyTextStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		'& div p:last-child': {
			marginBottom: '39px'
		}
	}));
	
	var whatAreEatingDisordersStyle = /*#__PURE__*/exports.whatAreEatingDisordersStyle = (0, _emotion.css)((_css5 = {
		position: 'relative',
		margin: '30px 0'
	}, _css5['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		margin: '150px 0'
	}, _css5));
	
	var disordersLeftStyle = /*#__PURE__*/exports.disordersLeftStyle = (0, _emotion.css)((_css6 = {}, _css6['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		width: '500px'
	}, _css6));
	
	var disordersRightStyle = /*#__PURE__*/exports.disordersRightStyle = (0, _emotion.css)((_css7 = {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		right: '0'
	
	}, _css7['@media (min-width: ' + _globalStyles.mobileMinWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css7['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		display: 'block',
		width: '258px'
	}, _css7['@media (min-width: ' + _globalStyles.tabletLandscapeMinWidthBreakpoint + 'px)'] = {
		width: '384px'
	}, _css7['@media (min-width: ' + _globalStyles.desktopMinWidthBreakpoint + 'px)'] = {
		width: '529px'
	}, _css7['& > div'] = (_div = {
		position: 'relative',
		zIndex: '2',
		width: '100%'
	
	}, _div['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		display: 'block',
		paddingLeft: '19px',
		width: '212px'
	}, _div['@media (min-width: ' + _globalStyles.tabletLandscapeMinWidthBreakpoint + 'px)'] = {
		paddingLeft: '57px',
		width: '287px'
	}, _div['@media (min-width: ' + _globalStyles.desktopMinWidthBreakpoint + 'px)'] = {
		paddingLeft: '51px',
		width: '376px'
	}, _div['& p:first-child'] = _extends({}, _globalStyles.museo900, (_extends4 = {
		color: _globalStyles.orange,
		margin: '0'
	
	}, _extends4['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		fontSize: '36px',
		lineHeight: '43px'
	}, _extends4['@media (min-width: ' + _globalStyles.tabletLandscapeMinWidthBreakpoint + 'px)'] = {
		fontSize: '50px',
		lineHeight: '60px'
	}, _extends4['@media (min-width: ' + _globalStyles.desktopMinWidthBreakpoint + 'px)'] = {
		fontSize: '64px',
		lineHeight: '77px'
	}, _extends4)), _div['& p:last-child'] = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		color: _globalStyles.darkGrey,
		margin: 0
	})), _div), _css7['&:after'] = {
		zIndex: '1',
		position: 'absolute',
		width: '100%',
		height: '1360px',
		content: '" "',
		display: 'block',
		top: '50%',
		right: '0',
		backgroundImage: 'url(' + _circleBg2.default + ')',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center right',
		backgroundSize: '100%',
		transform: 'translateY(-50%)'
	}, _css7));
	
	var disordersMobileStyle = /*#__PURE__*/exports.disordersMobileStyle = (0, _emotion.css)((_css8 = {}, _css8['@media (max-width: ' + _globalStyles.mobileMinWidthBreakpoint + 'px)'] = {
		display: 'block'
	}, _css8['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css8['& p:first-child'] = _extends({}, _globalStyles.museo900, {
		color: _globalStyles.orange,
		margin: '0',
		fontSize: '20px',
		lineHeight: '24px'
	}), _css8['& p:last-child'] = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		color: _globalStyles.darkGrey,
		fontSize: '14px',
		margin: 0
	})), _css8));
	
	var areYouAtRiskSectionStyle = /*#__PURE__*/exports.areYouAtRiskSectionStyle = (0, _emotion.css)((_css9 = {
		position: 'relative',
		padding: '30px 0'
	}, _css9['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		padding: '100px 0'
	}, _css9));
	
	var atRiskLeftStyle = /*#__PURE__*/exports.atRiskLeftStyle = (0, _emotion.css)({
		maxWidth: '610px'
	});
	
	var atRiskRightStyle = /*#__PURE__*/exports.atRiskRightStyle = (0, _emotion.css)((_css10 = {
		'& [data-component=Card]': {
			width: '276px'
		}
	}, _css10['@media (min-width: ' + _globalStyles.tabletLandscapeMinWidthBreakpoint + 'px)'] = {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		right: '0',
		width: '384px',
		paddingLeft: '57px'
	}, _css10['@media (min-width: ' + _globalStyles.desktopMinWidthBreakpoint + 'px)'] = {
		width: '529px',
		paddingLeft: '51px'
	}, _css10));
	
	var resourceSectionStyle = exports.resourceSectionStyle = (0, _emotion.cx)((0, _globalStyles.contentSection)(), /*#__PURE__*/(0, _emotion.css)((_css11 = {}, _css11['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		padding: '100px 0'
	}, _css11)));
	
	var resourceSectionInnerStyle = exports.resourceSectionInnerStyle = (0, _emotion.cx)((0, _globalStyles.cardSection)(0), /*#__PURE__*/(0, _emotion.css)({
		'& [data-component=ArrowLink]': {
			color: _globalStyles.pink
		}
	}));
	
	var updatesSectionStyle = exports.updatesSectionStyle = (0, _emotion.cx)((0, _globalStyles.contentSection)(), /*#__PURE__*/(0, _emotion.css)((_css12 = {
		backgroundColor: '#fff',
		overflowX: 'hidden'
	}, _css12['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		padding: '150px 0'
	}, _css12)));
	
	var updatesInnerWrapperStyle = exports.updatesInnerWrapperStyle = (0, _emotion.cx)(innerWrapperStyle, /*#__PURE__*/(0, _emotion.css)({
		overflowX: 'initial'
	}));
	
	var updatesSectionInnerStyle = /*#__PURE__*/exports.updatesSectionInnerStyle = (0, _emotion.css)({
		'& header': {
			marginBottom: '25px',
			position: 'relative',
			'& a': (_a = {
				position: 'absolute',
				top: '50%',
				right: '0',
				transform: 'translateY(-50%)',
				color: _globalStyles.grey,
				textDecoration: 'none',
				fontSize: '16px',
				'& svg': {
					marginLeft: '4px'
				}
			}, _a['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
				fontSize: '12px',
				lineHeight: '24px',
				'& svg': {
					display: 'none'
				}
			}, _a)
		}
	});
	
	var ourPartnersSectionStyle = exports.ourPartnersSectionStyle = (0, _emotion.cx)((0, _globalStyles.contentSection)('#fff', '30px'), /*#__PURE__*/(0, _emotion.css)((_css13 = {
		'& h1': {
			width: 'auto',
			textAlign: 'center',
			marginBottom: '30px'
		}
	}, _css13['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '30px 0'
	}, _css13['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		padding: '100px 0',
		'& h1': {
			marginBottom: '60px'
		}
	}, _css13)));
	
	var ourPartnersLogosWrapperStyle = /*#__PURE__*/exports.ourPartnersLogosWrapperStyle = (0, _emotion.css)((_css14 = {
		display: 'flex',
		justifyContent: 'center',
		'& > a': {
			margin: '0 50px',
			'& img': {
				width: '100%'
			},
			'&:first-child': {
				maxWidth: '255px'
			},
			'&:last-child': {
				maxWidth: '299px'
			}
		}
	}, _css14['@media (max-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		'& > a': {
			margin: '0 25px'
		}
	}, _css14['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		flexFlow: 'column',
		alignItems: 'center',
		'& > a': {
			margin: '25px 0 0 0',
			'&:first-child': {
				marginTop: '0'
			},
			'& img': {
				width: '100%'
			}
		}
	}, _css14));
	
	var whoAreWeSectionStyle = /*#__PURE__*/exports.whoAreWeSectionStyle = (0, _emotion.css)((_css15 = {
		background: _globalStyles.pink,
		padding: '30px 0'
	}, _css15['@media (min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		background: _globalStyles.pink + ' url(' + _whoWeAre2.default + ') no-repeat right 80px center',
		padding: '100px 0'
	}, _css15));
	
	var whoAreWeInnerStyle = /*#__PURE__*/exports.whoAreWeInnerStyle = (0, _emotion.css)((_css16 = {
		maxWidth: '610px'
	}, _css16['& .' + titleStyle + ', & .' + bodyTextStyle + ', & [data-component=ArrowLink]'] = {
		color: '#fff'
	}, _css16));

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _withVariants;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _componentManager = __webpack_require__(377);
	
	var _navManager = __webpack_require__(22);
	
	var _cards = __webpack_require__(17);
	
	var _carousel = __webpack_require__(976);
	
	var _carouselCard = __webpack_require__(949);
	
	var _colouredCard = __webpack_require__(61);
	
	var _eLearningCard = __webpack_require__(246);
	
	var _newsCard = __webpack_require__(120);
	
	var _arrowLink = __webpack_require__(52);
	
	var _getInvolved = __webpack_require__(254);
	
	var _myselfBg = __webpack_require__(366);
	
	var _myselfBg2 = _interopRequireDefault(_myselfBg);
	
	var _someoneIKnowBg = __webpack_require__(367);
	
	var _someoneIKnowBg2 = _interopRequireDefault(_someoneIKnowBg);
	
	var _healthProfessionalBg = __webpack_require__(434);
	
	var _healthProfessionalBg2 = _interopRequireDefault(_healthProfessionalBg);
	
	var _researcherBg = __webpack_require__(770);
	
	var _researcherBg2 = _interopRequireDefault(_researcherBg);
	
	var _globalStyles = __webpack_require__(4);
	
	var _heroMobile = __webpack_require__(3711);
	
	var _heroMobile2 = _interopRequireDefault(_heroMobile);
	
	var _heroH = __webpack_require__(3710);
	
	var _heroH2 = _interopRequireDefault(_heroH);
	
	var _heroVp = __webpack_require__(3712);
	
	var _heroVp2 = _interopRequireDefault(_heroVp);
	
	var _pageStyles = __webpack_require__(1062);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColouredCardVariant = (0, _componentManager.withVariants)(_colouredCard.ColouredCard, (_withVariants = {}, _withVariants['max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px'] = 'compressed', _withVariants['max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px'] = 'compressedOneColumn', _withVariants['max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px'] = 'minimized', _withVariants));
	
	
	var ResourcePropType = _propTypes2.default.shape({
		title: _propTypes2.default.string,
		type: _propTypes2.default.string,
		date: _propTypes2.default.string,
		fields: _propTypes2.default.shape({
			thumbnail_image: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.shape({
					resize: _propTypes2.default.shape({
						src: _propTypes2.default.string.isRequired
					}).isRequired
				}).isRequired
			}).isRequired
		}),
		attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			vimeo_url: _propTypes2.default.string
		}))
	}).isRequired;
	
	var UpdatesPropType = _propTypes2.default.shape({
		id: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		date: _propTypes2.default.string,
		start_time: _propTypes2.default.string,
		end_time: _propTypes2.default.string,
		extract: _propTypes2.default.string.isRequired,
		fields: _propTypes2.default.shape({
			thumbnail_image: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.shape({
					resize: _propTypes2.default.shape({
						src: _propTypes2.default.string.isRequired
					}).isRequired
				}).isRequired
			}).isRequired
		})
	});
	
	var HomePage = function (_React$PureComponent) {
		_inherits(HomePage, _React$PureComponent);
	
		function HomePage() {
			_classCallCheck(this, HomePage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		HomePage.prototype.render = function render() {
			var _ref;
	
			var pageSettings = this.props.data.page.edges[0].node;
			var resources = [pageSettings.resource_1, pageSettings.resource_2, pageSettings.resource_3];
			var updates = pageSettings.updates.map(function (u) {
				return u.news || u.event || u.blog || u.podcast || u.resource || u.research_trial || u.employment || u.research_position;
			}).filter(function (u) {
				return u != null;
			});
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(_reactHelmet.Helmet, { title: 'Home' }),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.heroStyle },
					_react2.default.createElement(
						'div',
						{ className: (0, _pageStyles.heroBackgroundStyle)(_heroMobile2.default) },
						_react2.default.createElement(
							'video',
							{ autoPlay: 'autoplay', loop: 'loop', muted: 'muted' },
							_react2.default.createElement('source', { src: _heroH2.default, type: 'video/mp4', codecs: 'avc1.42E01E' }),
							_react2.default.createElement('source', { src: _heroVp2.default, type: 'video/webm', codecs: 'vp8' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'h1',
							{ className: _pageStyles.heroTitleStyle },
							pageSettings.heading
						),
						_react2.default.createElement(
							'p',
							{ className: _pageStyles.heroBodyStyle },
							pageSettings.body
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.cardsStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'p',
							{ className: _pageStyles.heroBodyCTAStyle },
							pageSettings.call_to_action
						),
						_react2.default.createElement(
							_cards.Cards,
							{
								columns: 4,
								scrollable: false,
								columnsAt: (_ref = {}, _ref['max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint] = 1, _ref)
							},
							_react2.default.createElement(ColouredCardVariant, {
								id: 0,
								to: '/for-myself',
								background: '#F5A81E url(' + _myselfBg2.default + ') no-repeat bottom right',
								minHeight: 210,
								title: 'I am here for myself',
								arrow: true
							}),
							_react2.default.createElement(ColouredCardVariant, {
								id: 1,
								to: '/carer',
								background: '#F26C22 url(' + _someoneIKnowBg2.default + ') no-repeat bottom right',
								minHeight: 210,
								title: 'Someone I know may need help',
								arrow: true
							}),
							_react2.default.createElement(ColouredCardVariant, {
								id: 2,
								to: '/health-professionals',
								background: _globalStyles.blue + ' url(' + _healthProfessionalBg2.default + ') no-repeat bottom right',
								minHeight: 210,
								title: 'I am a health professional',
								arrow: true
							}),
							_react2.default.createElement(ColouredCardVariant, {
								id: 3,
								to: '/research',
								background: _globalStyles.purple + ' url(' + _researcherBg2.default + ') no-repeat bottom right',
								minHeight: 210,
								title: 'I am a researcher',
								arrow: true
							})
						)
					)
				),
				updates.length > 0 && _react2.default.createElement(
					'section',
					{ className: _pageStyles.updatesSectionStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.updatesInnerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.updatesSectionInnerStyle },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _pageStyles.titleStyle },
									'Latest Updates'
								)
							),
							_react2.default.createElement(
								_carousel.Carousel,
								null,
								updates.map(function (node, index) {
									return _react2.default.createElement(_carouselCard.CarouselCard, {
										key: index,
										to: (0, _navManager.idToLink)(node.id),
										title: node.title,
										body: node.extract || node.project_extract,
										date: node.date || node.start_time || node.recruitment_open_date,
										endDate: node.end_time || node.recruitment_close_date,
										background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
									});
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.whoAreWeSectionStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.whoAreWeInnerStyle },
							_react2.default.createElement(
								'h1',
								{ className: _pageStyles.titleStyle },
								pageSettings.content_heading_2
							),
							_react2.default.createElement(
								'div',
								{ className: _pageStyles.bodyTextStyle },
								_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: pageSettings.content_block_2 } }),
								_react2.default.createElement(
									_arrowLink.ArrowLink,
									{ to: pageSettings.content_link_url_2 },
									pageSettings.content_link_text_2
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.areYouAtRiskSectionStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.atRiskLeftStyle },
							_react2.default.createElement(
								'h1',
								{ className: _pageStyles.titleStyle },
								pageSettings.assessment_heading
							),
							_react2.default.createElement(
								'div',
								{ className: _pageStyles.bodyTextStyle },
								_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: pageSettings.assessment_body } })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.atRiskRightStyle },
							_react2.default.createElement(_colouredCard.ColouredCard, {
								id: 1,
								to: pageSettings.button_url,
								background: _globalStyles.aqua,
								minHeight: 164,
								title: pageSettings.button_text,
								arrow: true
							})
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.resourceSectionStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.resourceSectionInnerStyle },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _pageStyles.titleStyle },
									'Our Resources'
								),
								_react2.default.createElement(
									_arrowLink.ArrowLink,
									{ to: '/resource-library' },
									'View All Resources'
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 3 },
								resources.map(function (node, index) {
									return _react2.default.createElement(_eLearningCard.ELearningCard, {
										key: index,
										to: (0, _navManager.idToLink)(node.id),
										mediaImage: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
										hasVideo: !!node.attachments.find(function (a) {
											return a.vimeo_url;
										}),
										title: node.title,
										body: node.extract,
										linkText: node.tile_button_text || 'Watch the Demo'
									});
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: _pageStyles.ourPartnersSectionStyle },
					_react2.default.createElement(
						'div',
						{ className: _pageStyles.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _pageStyles.titleStyle },
								pageSettings.partners_heading
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _pageStyles.ourPartnersLogosWrapperStyle },
							pageSettings.partner_logos.map(function (logo, index) {
								return _react2.default.createElement(
									'a',
									{ key: index, href: logo.link_url, target: 'blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', { src: logo.logo, alt: logo.alt_text })
								);
							})
						)
					)
				),
				_react2.default.createElement(_getInvolved.GetInvolved, null)
			);
		};
	
		return HomePage;
	}(_react2.default.PureComponent);
	
	HomePage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						heading_image: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						call_to_action: _propTypes2.default.string.isRequired,
						updates: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							news: UpdatesPropType,
							event: UpdatesPropType
						})),
						content_heading_2: _propTypes2.default.string.isRequired,
						content_block_2: _propTypes2.default.string.isRequired,
						content_link_text_2: _propTypes2.default.string.isRequired,
						content_link_url_2: _propTypes2.default.string.isRequired,
						assessment_heading: _propTypes2.default.string.isRequired,
						assessment_body: _propTypes2.default.string.isRequired,
						button_text: _propTypes2.default.string.isRequired,
						button_url: _propTypes2.default.string.isRequired,
						partners_heading: _propTypes2.default.string.isRequired,
						partner_logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							logo: _propTypes2.default.string.isRequired,
							alt_text: _propTypes2.default.string,
							link_url: _propTypes2.default.string
						}).isRequired),
						resource_1: ResourcePropType,
						resource_2: ResourcePropType,
						resource_3: ResourcePropType
					})
				}))
			})
		})
	};
	exports.default = HomePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4cd02913506167c53ea3.js